// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper";

import "swiper/css";
import "./sliderChart.scss";
import { FormattedMessage } from "react-intl";
// import Divider from "component/divider/divider";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import { useSelector } from "react-redux";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import useSWR from "swr";
import { END_POINTS } from "constants/APIConstant";
import IndicatorCard from "./components/indicatorCard";
import React from "react";

function SliderChart() {
  const carouselRef = React.useRef(null);
  const dir = useSelector(({ theme }) => theme.direction);

  const sliderData = useSWR({
    url: END_POINTS.SELECTED_INDICATOR,
  });

  const options = {
    loop: false,
    autoplay: false,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    // center: true,
    // margin: 30,
    nav: true,
    dots: false,
    responsiveClass: true,
    smartSpeed: 500,
    dir: "ltr",
    responsive: {
      0: {
        items: 1,
      },
      550: {
        items: 2,
      },
      768: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
    },
  };

  const fetchingData = () => {
    const indicatorsData =
      sliderData.error ||
      sliderData.isLoading ||
      sliderData.data === undefined ||
      sliderData.data === null
        ? []
        : sliderData.data.data;

    const render =
      Object.keys(indicatorsData).length > 4 ? (
        <OwlCarousel ref={carouselRef} className="owl-theme" {...options}>
          {indicatorsData.map(
            (
              {
                icon,
                selectedIndicatorTranslations,
                studyPeriod,
                title,
                unit,
                value,
              },
              i
            ) => (
              <IndicatorCard
                key={i}
                icon={icon}
                translation={selectedIndicatorTranslations}
                studyPeriod={studyPeriod}
                title={title}
                unit={unit}
                value={value}
              />
            )
          )}
        </OwlCarousel>
      ) : Object.keys(indicatorsData).length > 0 ? (
        <div className="row">
          {indicatorsData.map(
            (
              {
                icon,
                selectedIndicatorTranslations,
                studyPeriod,
                title,
                unit,
                value,
              },
              i
            ) => (
              <div key={i} className="col-12 col-md-3">
                <IndicatorCard
                  key={i}
                  icon={icon}
                  translation={selectedIndicatorTranslations}
                  studyPeriod={studyPeriod}
                  title={title}
                  unit={unit}
                  value={value}
                />
              </div>
            )
          )}
        </div>
      ) : (
        <DataNotFound />
      );

    return render;
  };

  // Keyboard navigation for slider
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      // Get carousel instance
      let carousel = null;
      if (carouselRef.current) {
        const carouselEl = carouselRef.current;
        if (carouselEl?.carousel) carousel = carouselEl.carousel;
        if (carouselEl?.owlCarousel) carousel = carouselEl.owlCarousel;
      }

      // Try to get from DOM using jQuery (OwlCarousel uses jQuery)
      if (!carousel) {
        const sliderElement = document.querySelector(
          ".selected-indicators-slider .owl-carousel"
        );
        if (
          sliderElement &&
          window.$ &&
          window.$(sliderElement).data("owl.carousel")
        ) {
          carousel = window.$(sliderElement).data("owl.carousel");
        }
      }

      if (!carousel) return;

      // Check if slider is in viewport
      const sliderElement = document.querySelector(".slider-chart-slider");
      if (!sliderElement) return;

      const rect = sliderElement.getBoundingClientRect();
      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;

      if (!isInViewport) return;

      // Handle arrow keys
      if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
        const isInputFocused =
          document.activeElement?.tagName === "INPUT" ||
          document.activeElement?.tagName === "TEXTAREA";

        if (isInputFocused) return; // Don't interfere with input fields

        event.preventDefault();
        event.stopPropagation();

        try {
          if (event.key === "ArrowLeft") {
            carousel.prev();
          } else if (event.key === "ArrowRight") {
            carousel.next();
          }
        } catch (error) {
          console.error("Error navigating carousel:", error);
        }
      }
    };

    // Add event listener with a delay to ensure carousel is initialized
    const timeoutId = setTimeout(() => {
      window.addEventListener("keydown", handleKeyDown);
    }, 500);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [sliderData?.data?.data]);

  return (
    <ContentLoading isLoading={sliderData.isLoading}>
      <div
        className={`slider-chart-slider ${
          sliderData?.data?.data?.length < 6 && "nav-none"
        }`}
        tabIndex={0}
      >
        <div className="container">
          {/* <Divider /> */}
          <div className="section-title">
            <FormattedMessage id="indicators" />
          </div>
          {/* <Swiper
            modules={[Navigation]}
            navigation={{
              prevEl: ".prev",
              nextEl: ".next",
            }}
            spaceBetween={20}
            breakpoints={{
              0: {
                // width: 640,
                slidesPerView: 1,
              },
              // when window width is >= 640px
              640: {
                width: 640,
                slidesPerView: 1,
              },
              // when window width is >= 768px
              768: {
                width: 768,
                slidesPerView: 3,
              },
            }}
            slidesPerView={5}
          >
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up1.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up2.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up3.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/bootom.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up4.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up5.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/bootom.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up6.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="s-card">
                <div className="scard_head">
                  <h4>7,740</h4>
                  <h6>مليون دولار</h6>
                </div>
                <div className="scard_body">
                  <img
                    className="img1"
                    src={process.env.PUBLIC_URL + "/image/up7.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                  <img
                    className="up"
                    src={process.env.PUBLIC_URL + "/image/top.svg"}
                    alt="slide-item"
                    loading="lazy"
                  />
                </div>
                <div className="scard_foot">
                  <h5>التجارة الخارجية - واردات</h5>
                  <h6>(مارس 2022)</h6>
                </div>
              </div>
            </SwiperSlide>

            <div className="prev">
              <i className="fa fa-angle-left"></i>
            </div>
            <div className="next">
              <i className="fa fa-angle-right"></i>
            </div>
          </Swiper> */}

          <div
            className={`selected-indicators-slider ${
              dir === "rtl" ? "dir-r" : "dir-l"
            }`}
          >
            {fetchingData()}
          </div>
        </div>
      </div>
    </ContentLoading>
  );
}

export default SliderChart;
